import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGreenCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.0001 1.66669C5.40008 1.66669 1.66675 5.40002 1.66675 10C1.66675 14.6 5.40008 18.3334 10.0001 18.3334C14.6001 18.3334 18.3334 14.6 18.3334 10C18.3334 5.40002 14.6001 1.66669 10.0001 1.66669ZM8.33342 14.1667L4.16675 10L5.34175 8.82502L8.33342 11.8084L14.6584 5.48335L15.8334 6.66669L8.33342 14.1667Z",
		fill: "#00AB50"
	})
});
export default SvgGreenCheck;
